import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner or team admin, you can add or remove package access to or from teams in your organization.`}</p>
    <h2>{`Adding package access to a team`}</h2>
    <h3>{`Adding package access to a team on the web`}</h3>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the team to which you want to add package access, click `}<strong parentName="p">{`Packages`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-packages-button.png" alt="Screenshot of the packages button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the "Add Packages" page, in the "Package" field, type the name of the package and select from the dropdown menu.`}</p>
        <Screenshot src="/organizations/managing-teams/team-package-select.png" alt="Screenshot of the package selection" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ Add Existing Package`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-package-add-existing-button.png" alt="Screenshot of the add package button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the package name, click `}<strong parentName="p">{`read`}</strong>{` or `}<strong parentName="p">{`read/write`}</strong>{` to set the team permissions for the package.`}</p>
        <Screenshot src="/organizations/managing-teams/team-package-permissions.png" alt="Screenshot of the team package permission option" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Adding package access to a team using the CLI`}</h3>
    <p>{`As an organization owner or team admin, you can use the CLI `}<inlineCode parentName="p">{`access`}</inlineCode>{` command to add package access to a team on
the command line:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm access grant <read-only|read-write> <org:team> [<package>]
`}</code></pre>
    <p>{`For more information, see "`}<a parentName="p" {...{
        "href": "/cli/access"
      }}>{`npm-access`}</a>{`".`}</p>
    <h2>{`Removing package access from a team`}</h2>
    <h3>{`Removing package access from a team on the web`}</h3>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the team from which you want to remove package access, click `}<strong parentName="p">{`Packages`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-packages-button.png" alt="Screenshot of the packages button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the name of the package from which you want to remove access, click `}<strong parentName="p">{`x`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-package-remove-button.png" alt="Screenshot of the remove package button" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Removing package access from a team using the CLI`}</h3>
    <p>{`As an organization owner or team admin, you can also use the CLI `}<inlineCode parentName="p">{`access`}</inlineCode>{` command to revoke package access from a team on
the command line:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm access revoke <org:team> [<package>]
`}</code></pre>
    <p>{`For more information, see "`}<a parentName="p" {...{
        "href": "/cli/access"
      }}>{`npm-access`}</a>{`".`}</p>
    <h2>{`Changing package access for a team`}</h2>
    <h3>{`Changing package access for a team on the web`}</h3>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the team from which you want to remove package access, click `}<strong parentName="p">{`Packages`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-packages-button.png" alt="Screenshot of the packages button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the package name, click `}<strong parentName="p">{`read`}</strong>{` or `}<strong parentName="p">{`read/write`}</strong>{` to set the team permissions for the package.`}</p>
        <Screenshot src="/organizations/managing-teams/team-package-change-permissions.png" alt="Screenshot of the change package permission option" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Changing package access for a team from the CLI`}</h3>
    <p>{`As an organization owner or team admin, you can change package access for a team from the command line:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm access
`}</code></pre>
    <p>{`For more information, see the `}<a parentName="p" {...{
        "href": "/cli/access"
      }}><inlineCode parentName="a">{`npm-access`}</inlineCode>{` CLI documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      